import React, { Component } from 'react';
import config from '../../../config';
import common from '../../../common';

class MdStatusEot extends Component {
    constructor(props) {
        super(props);
        this.state = {
            enumText: {
                'UT_CRT': { trans: 'createTeam', path: '/create-team' },
                'UT_TRF': { trans: 'manageTeam', path: '/manage-team' },
                'UT_LIVE': { trans: 'viewTeam', path: '/manage-team' },
                'UT_SUB': { trans: 'makeSubstitutions', path: '/manage-team' }
            },
        }
    }

    componentDidMount(){
        common.cardImpression('card-points', {variant : 'season', position : '3'})
    }

    renderDetails(arrMatchDay, trans) {
        let resp = null;
        resp = arrMatchDay && arrMatchDay.map((element, index) => {
            const { CurPoints, GamedayId } = element;

            let nodePoints = <span className="si-points"> - </span>;
            if (CurPoints) {
                nodePoints = (<React.Fragment>
                    <span className="si-points">{CurPoints} </span><span className="si-pts-txt">{trans.labelPts}</span>
                </React.Fragment>)
            }
            const selectedLabel = trans['rd' + GamedayId];


            return (<div key={index} className="si-stats-wrap" >
                <span className="si-plyr-events">{selectedLabel}</span>
                <div className="si-pts-wrap">
                    {
                        nodePoints
                    }
                </div>
            </div>)


        });
        return resp;
    }



    renderViewPointsBtn(trans) {

        let self = this;
        return (<div className="si-btn btn-lg" onClick={() => {
            common.customTracking('Fantasy Football - Points');
            self.onRedirectTo()
        }}>{trans.viewPoints}</div>);

    }

    onRedirectTo() {
        const { PtGameday } = this.props.gcStats;
        let enumText = this.state.enumText;
        let objText = enumText[this.props.enumUserScinarioCode];
        if (objText) {
            let sPath = objText.path;
            if (PtGameday) {
                sPath += '/' + PtGameday;
            }
            this.props.onRedirectTo(sPath);
        }
    }

    render() {
        let self = this;
        let trans = this.props.trans;
        let gcStats = this.props.gcStats;
        let arrMatchDay = [];
        let gamdayId = 0;
        let arrSchedule = [config.enumscinarioCode.preUnkownFixture, config.enumscinarioCode.preKownFixture, config.enumscinarioCode.startOfMatchDayBefore6Hour];
        let IsFixturePtCard = config.enumMdCardStatus.fixture;
        let isMdCompleted = false;

        let sRoundName = trans.lastSeason;
        let enumScinarioCode = self.props.enumScinarioCode;
        let COOKIE_GM = config.COOKIE_GM;
        let parsedCookieGM = null;
        let cookieGM = common.getCookie(COOKIE_GM);
        let badgeID = 0;
        if (cookieGM) {
            parsedCookieGM = common.parseCookie(cookieGM);
            if (parsedCookieGM) {
                badgeID = parsedCookieGM.BadgeId;
            }
        }
        let imgSrc = config.playerImgBase + `badges/${badgeID}.png`;
        return <div className="si-card si-points-card">
            <div className="si-mypnts-block">
                <div className="si-mt-block">
                    <div className="si-pntcrd-block">
                        <div className="si-text-descp">{sRoundName}</div>
                        {
                            (self.props.eosStats && self.props.eosStats.TrPoints ? self.props.eosStats.TrPoints : "") + " " + trans.TotPts
                        }
                    </div>
                    <div className="si-mail-block">
                        <img src={imgSrc} alt={""} /></div>
                </div>
                <div className="si-points-block">
                    <div className="si-stats-details">
                        <div className="si-points-table">
                            {
                                self.renderDetails(self.props.finalMatchPoints, trans)
                            }
                        </div>
                    </div>
                </div>
                <div className="button-block">
                    {
                        self.renderViewPointsBtn(trans)
                    }
                </div>
            </div>
        </div>
    }
}

export default MdStatusEot;


// WEBPACK FOOTER //
// ./src/components/home/cards/MdStatusEot.js